import React from 'react';
import { Icons } from 'sarsaparilla';

const NoNeedToPermit = () => (
  <div>

    <div className="rec-questionnaire-result-title">
      You do not need a permit.
    </div>

    <div className="rec-questionnaire-result-icon">
      <Icons.IconPermit />
    </div>
  </div>
);

NoNeedToPermit.propTypes = {

};

export default NoNeedToPermit;
